<div class="card">
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10 header">
      <span class="header">Auto-Purchase History</span>
    </div>
    <div class="col-1">
      <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"
        style="margin-right:10px; margin-top:10px;" (click)="openInventoryRequestLists()"></button>
    </div>
    <hr class="divider" />
  </div>
  <div class="row">
    <div class="col-12">
      <ag-grid-angular id="dispo_list" style="width: 98%; height: 83vh; display: inline-block; margin-left: 1%"
         [columnDefs]="columnDefs" [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions" [rowData]="dummyDataService.auto_purchase_history"
        [overlayLoadingTemplate]="overlayLoadingTemplate" [animateRows]="true"
        [components]="components" [enableBrowserTooltips]="true"></ag-grid-angular>
    </div>
  </div>
</div>